<template>
  <div class="slide-wrapper zoom" v-parallax-fit="slide_wrapper">
    <div class="slide photo" ref="child_care_sign" v-parallax-fit="parallax"></div>
    <div class="slide photo1" v-parallax-fit="photo1"></div>
    <div class="slide closed_sign" v-parallax-fit="closed_sign"></div>
  </div>
</template>

<script>
export default {
  name: 'slide21',
  data() {
    return {
      slide_wrapper: [
        {
          start: 29600,
          end: 30000,
          fromStyle: { transform: 'translateY(0px)' },
          toStyle: { transform: 'translateY(1000px)' },
          easing: 'linear'
        },
      ],
      parallax: [
        {
          start: 23500,
          end: 24000,
          fromStyle: { transform: 'translateY(-1400px)  rotateZ(0deg)' },
          toStyle: { transform: 'translateY(0px) rotateZ(10deg)' },
          easing: 'linear'
        },
      ],
      photo1: [
        {
          start: 24500,
          end: 25000,
          fromStyle: { transform: 'translateY(-1300px)  rotateZ(0deg)' },
          toStyle: { transform: 'translateY(0px) rotateZ(10deg)' },
          easing: 'linear'
        },
        {
          start: 27600,
          end: 28000,
          fromStyle: { transform: 'translateY(0px)  rotateZ(0deg)' },
          toStyle: { transform: 'translateY(1400px) rotateZ(0deg)' },
          easing: 'linear'
        }
      ],
      closed_sign: [
        {
          start: 28800,
          end: 29100,
          fromStyle: { opacity: 0 },
          toStyle: { opacity: 1 },
          easing: 'easeOutExpo'
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.slide-wrapper {
  transition: 0.5s;
  height: 100%;
}
.photo {
  position: absolute;
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/21_ChildCare.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 310px;
  height: 350px;
  left: -142px;
  top: calc(50% + 52px);
  transition: 0.5s;
  z-index: 3;
  @media(max-width: 600px) {
    width: 100px;
    height: 160px;
    left: -92px;
    top: calc(50% + 62px);
  }
  @media(max-width: 400px) {
    top: calc(50% + 32px);
  }
}
.photo1 {
  position: absolute;
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/21_Photo_2.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 510px;
  height: 620px;
  left: -242px;
  top: calc(50% - 282px);
  transition: 0.5s;
  z-index: 2;
  @media(max-width: 600px) {
    width: 200px;
    height: 250px;
    left: -94px;
    top: 292px;
  }
  @media(max-width: 400px) {
    top: 182px;
  }
}
.closed_sign {
  position: absolute;
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/21_ClosedSign.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 165px;
  height: 120px;
  left: -65px;
  top: calc(50% + 140px);
  transition: 0.5s;
  z-index: 4;
  transform: rotate(7deg);
  @media(max-width: 600px) {
    width: 61px;
    height: 54px;
    left: -72px;
    top: calc(50% + 107px);
  }
  @media(max-width: 400px) {
    top: calc(50% + 77px);
  }
}
</style>
